const yellow = "#ffff00";
const yellowDim = "#cccc00";
const yellowSoft = "#ffff66";
const black = "#000000";
const charcoal = "#1a1a1a";
const slate = "#2a2a2a";
const grey = "#888888";
const greyLight = "#bbbbbb";
const greyLighter = "#dddddd";
const offWhite = "#e6e6e6";
const red = "#ff5555";
const green = "#22ff55";

const sharedPalette = {
  neutral: {
    serious: charcoal,
    standard: black,
    fun: slate,
  },
  bold: {
    serious: greyLighter,
    standard: offWhite,
    fun: grey,
  },
  gray: {
    serious: greyLight,
    standard: slate,
    fun: grey,
  },
  primary: {
    serious: green,
    standard: charcoal,
    fun: slate,
  },
  secondary: {
    serious: yellow,
    standard: yellowDim,
    fun: yellowSoft,
  },
  tertiary: {
    serious: yellow,
    standard: charcoal,
    fun: grey,
  },
  accent: {
    serious: yellowDim,
    standard: yellow,
    fun: yellowSoft,
  },
  warning: {
    serious: red,
    standard: "#ff8844",
    fun: "#ffaa66",
  },
  celebration: {
    serious: yellowDim,
    standard: yellowSoft,
    fun: yellow,
  },
};

export default {
  "light-mode": sharedPalette,
  "dark-mode": sharedPalette,
};
